import { AxiosPromise } from "axios";
import { ApiRequestAdapter } from "../../common/api/ApiRequestAdapter";
import { apiService } from "../../common/api/apiService";
import { HttpMethod } from "../../common/api/http";
import { EntityIdObject, EntityObject } from "../../common/types";
import { serializeParams } from "../../common/utils/apiUtils";
import {
  AssignFinancialMediation,
  ChangeFinancialMediationVersion,
  CreateUpdateFinancialMediation,
  FillFinancialMediation,
  FinancialMediation,
  FinancialMediationFilterPageRequest,
  FinancialMediationFilterPageResult,
  FinancialMediationGenerateRequest,
} from "./types";

const FILTER_FINANCIAL_MEDIATIONS = ApiRequestAdapter.create("/financial-mediations", HttpMethod.GET);
const GET_FINANCIAL_MEDIATION = ApiRequestAdapter.create("/financial-mediations/{0}", HttpMethod.GET);
const CREATE_FINANCIAL_MEDIATION = ApiRequestAdapter.create("/financial-mediations", HttpMethod.POST);
const UPDATE_FINANCIAL_MEDIATION = ApiRequestAdapter.create("/financial-mediations/{0}", HttpMethod.PUT);
const DELETE_FINANCIAL_MEDIATION = ApiRequestAdapter.create("/financial-mediations/{0}", HttpMethod.DELETE);
const GENERATE_FINANCIAL_MEDIATION = ApiRequestAdapter.create("/financial-mediations/{0}/generate", HttpMethod.GET);
const CHANGE_FINANCIAL_MEDIATION_VERSION = ApiRequestAdapter.create(
  "/financial-mediations/{0}/change-version",
  HttpMethod.POST,
);
const ASSIGN_FINANCIAL_MEDIATION = ApiRequestAdapter.create("/financial-mediations/{0}/assign", HttpMethod.POST);
const FILL_FINANCIAL_MEDIATION = ApiRequestAdapter.create("/financial-mediations/fill", HttpMethod.POST);

export const financialMediationApi = {
  filterFinancialMediations: (
    request: FinancialMediationFilterPageRequest,
  ): AxiosPromise<FinancialMediationFilterPageResult> => {
    return apiService.get(FILTER_FINANCIAL_MEDIATIONS.url, {
      params: request,
      paramsSerializer: { serialize: serializeParams },
    });
  },
  getFinancialMediation: (request: EntityIdObject): AxiosPromise<FinancialMediation> => {
    return apiService.get(GET_FINANCIAL_MEDIATION.getParametrizedUrl(request.id));
  },
  createFinancialMediation: (request: CreateUpdateFinancialMediation): AxiosPromise<FinancialMediation> => {
    return apiService.post(CREATE_FINANCIAL_MEDIATION.url, request);
  },
  updateFinancialMediation: (
    request: EntityObject<CreateUpdateFinancialMediation>,
  ): AxiosPromise<FinancialMediation> => {
    return apiService.put(UPDATE_FINANCIAL_MEDIATION.getParametrizedUrl(request.id), request.object);
  },
  deleteFinancialMediation: (request: EntityIdObject): AxiosPromise => {
    return apiService.delete(DELETE_FINANCIAL_MEDIATION.getParametrizedUrl(request.id));
  },
  generateFinancialMediation: (request: EntityObject<FinancialMediationGenerateRequest>): AxiosPromise<Blob> => {
    return apiService.get(GENERATE_FINANCIAL_MEDIATION.getParametrizedUrl(request.id), {
      params: request.object,
      responseType: "blob",
    });
  },
  changeFinancialMediationVersion: (
    request: EntityObject<ChangeFinancialMediationVersion>,
  ): AxiosPromise<FinancialMediation> => {
    return apiService.post(CHANGE_FINANCIAL_MEDIATION_VERSION.getParametrizedUrl(request.id), request.object);
  },
  assignFinancialMediation: (request: EntityObject<AssignFinancialMediation>): AxiosPromise<FinancialMediation> => {
    return apiService.post(ASSIGN_FINANCIAL_MEDIATION.getParametrizedUrl(request.id), request.object);
  },
  fillFinancialMediation: (request: FillFinancialMediation): AxiosPromise<Blob> => {
    return apiService.post(FILL_FINANCIAL_MEDIATION.url, request, { responseType: "blob" });
  },
};
